import { useLinked, useModel } from "@type-r/react";
import React from "react";
import { CreditNoteData } from "../../api/creditNoteChange";
import { AssetsSection } from "../assets-section";
import { InblockedAssetsDataStep } from "../inblocked-assets-data-step";
import { InblockedAssetsTitle } from "../inblocked-assets-title";
import { CreditNoteTile } from "./credit-note-tile";
import { CreditNoteExternalSystems } from "./externalSystems";

export const InblockedCreditNotesDataStep = ({ job, back, $assetTypeSelect, assetTypeMultiOptions, $refreshEvents, height }: { job, back?, $assetTypeSelect?, assetTypeMultiOptions?, $refreshEvents, height? }) => {
    const creditNoteChanges = useModel(CreditNoteData);
    const selectedCreditNotes = useModel(CreditNoteData);
    const $activeCreditNote = useLinked(null);
    const $filter = useLinked({ search: '', eventType: null });
    const $loadedAssetEvents = useLinked(false);

    const $selectAllAssets = useLinked(false);

    return <InblockedAssetsDataStep
        assetName='Credit Note'
        assetChanges={creditNoteChanges}
        selectedAssets={selectedCreditNotes}
        $filter={$filter}
        job={job}
        back={back}
        $loadedAssetEvents={$loadedAssetEvents}
        assetsListComponent={
            (filteredAssetChanges, itemsCount, $selectAllAssets, assetEventsGeneralCount) =>
                <AssetsSection
                    height={height ? height : 420}
                    title={<InblockedAssetsTitle assetChanges={creditNoteChanges.items} externalSystems={CreditNoteExternalSystems} $filter={$filter} $loadedAssetEvents={$loadedAssetEvents} importJobId={job.importJobId} itemsCount={itemsCount} assetEventsGeneralCount={assetEventsGeneralCount}/>}
                    assets={filteredAssetChanges}
                    assetTile={CreditNoteTile}
                    notExpanded={false}
                    $active={$activeCreditNote}
                    selected={selectedCreditNotes.items}
                    selectAllAssets={$selectAllAssets} />
        }
        externalSystems={CreditNoteExternalSystems}
        $assetTypeSelect={$assetTypeSelect}
        assetTypeMultiOptions={assetTypeMultiOptions}
        $refreshEvents={$refreshEvents}
        selectAllAssets={$selectAllAssets} />
};
